import {
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_md,
  font_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export const container = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing(4)};
  padding-bottom: ${spacing(4)};
`

export const identity = css`
  display: flex;
  align-items: center;
  gap: ${spacing(3)};
  min-width: 0;
`

export const text = css`
  display: flex;
  flex-direction: column;
  min-width: 0;
`

export const name = css`
  ${font_md};
  font-family: ${font_family_weight_medium};
  color: ${text_colorTextPrimary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const email = css`
  ${font_sm};
  font-family: ${font_family_weight_regular};
  color: ${text_colorTextSecondary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const pills = css`
  display: flex;
  align-items: center;
  gap: ${spacing(2)};
  flex-shrink: 0;
`

export const arrow = css`
  width: ${spacing(4)};
  height: ${spacing(4)};

  path {
    stroke: ${text_colorTextSecondary};
  }
`
